/* @ngInject */
const myWagonForm = (
  $$wagon,
  $$autocomplete,
  $$owner,
  $$sale,
  parkIdNewModal,
  toaster,
  wagonUtils,
  valueHandler,
  wagonLabels,
) => {
  return {
    restrict: 'E',
    scope: {
      myWagon: '=',
      enableValidator: '=?',
      disableId: '=?',
      enableCreation: '=?',
      enableIdNew: '=?',
    },
    template: require('./myWagonForm.html'),

    /* @ngInject */
    controller: (
      $scope
    ) => {
      $scope.fieldsOptions = $$wagon.metadata.fields

      $scope.isolatedRadios = [{
        label: 'Isolé',
        id: $scope.id + 'isolated',
        value: true,
      }, {
        label: 'Pas isolé',
        id: $scope.id + 'notIsolated',
        value: false,
      }, {
        label: 'Les deux',
        id: $scope.id + 'isolatedNull',
        value: undefined,
      },]

      $scope.damagedRadios = [{
        label: 'Avarié',
        id: $scope.id + 'damaged',
        value: true,
      }, {
        label: 'Pas avarié',
        id: $scope.id + 'notDamaged',
        value: false,
      }, {
        label: 'Les deux',
        id: $scope.id + 'damagedNull',
        value: undefined,
      },
      ]

      $scope.photoRadios = [{
        label: 'Photo',
        id: $scope.id + 'photo',
        value: true,
      }, {
        label: 'Pas de photo',
        id: $scope.id + 'notPhoto',
        value: false,
      }, {
        label: 'Les deux',
        id: $scope.id + 'photoNull',
        value: undefined,
      },]

      $scope.scrappedRadios = [{
        label: 'Ferraillé',
        id: $scope.id + 'scrapped',
        value: true,
      }, {
        label: 'Non ferraillé',
        id: $scope.id + 'notScrapped',
        value: false,
      }, {
        label: 'Les deux',
        id: $scope.id + 'scrappedNull',
        value: undefined,
      },]

      $scope.announceScrappingRadios = [{
        label: 'Annoncée en ferraillage',
        id: $scope.id + 'announceScrapping',
        value: true,
      }, {
        label: 'Non annoncée en ferraillage',
        id: $scope.id + 'notAnnounceScrapping',
        value: false,
      }, {
        label: 'Les deux',
        id: $scope.id + 'announceScrappingNull',
        value: undefined,
      },]

      $scope.saleName = {
        name: '',
      }

      $scope.$watch('saleName.name', async (_newName, _oldName) => {
        if (!_newName) return $scope.myWagon.saleId = null

        if (_newName !== _oldName) {
          const index = $scope.sales.findIndex(s => s.number === _newName)
          if (index === undefined || index < 0) {
            $scope.myWagon.saleId = -1
          } else {
            $scope.myWagon.saleId = $scope.sales[index].id
          }
        }
      }, true)

      $scope.reset = () => {
        if (toaster.confirm(wagonLabels.ask.clearFields)) {
          $scope.wagonForm.$setPristine()
          $scope.wagonForm.$setUntouched()
          $scope.saleName = { name: '', }
          $scope.myWagon.saleId = null
          if ($scope.disableId) {
            const id = $scope.myWagon.id
            $scope.myWagon = $$wagon.new.classic()
            $scope.myWagon.id = id
          } else {
            $scope.myWagon = $$wagon.new.classic()
          }
        }
      }

      $scope.$watch('myWagon.id', async (_newId, _oldId) => {
        if ($scope.enableCreation) {
          if (_newId !== _oldId && wagonUtils.isIdValid(_newId)) {
            _newId = wagonUtils.stringToId(_newId)

            try {
              const wagon = await $$wagon.request.getById(_newId)
              if (!wagon) return

              if (wagon.idNew === _newId) {
                await $$wagon.ask.renameWagon(wagon)
                return
              }

              if (valueHandler.isId(wagon.railwayId) || valueHandler.exists(wagon.position)) {
                toaster.message(wagonLabels.log.save.alreadyOnRailway, 'orange')
                $scope.myWagon.id = _newId.slice(0, 7)
              } else if (wagon.scrapped) {
                toaster.message(wagonLabels.log.save.scrapped, 'orange')
                $scope.myWagon.id = _newId.slice(0, 7)
              } else {
                toaster.message(wagonLabels.log.save.recoverData(wagonUtils.idToString(_newId)))
                $scope.myWagon = $$wagon.format.user(wagon)
                $scope.myWagon.id = _newId
              }
            } catch (error) {
              if (error === 'Impossible de récupérer le wagon. Ressource non trouvée') return
              toaster.message(error, 'orange')
            }
          }
        }
      })
    },
    link: {
      pre: (scope, element, attrs) => { },
      post: async (scope, element, attrs, ctrl) => {
        try {
          const requests = []
          requests.push($$owner.request.getAll())
          requests.push($$autocomplete.request.get('type', 'wagons'))
          requests.push($$autocomplete.request.get('set', 'wagons'))
          requests.push($$autocomplete.request.get('color', 'wagons'))
          requests.push($$autocomplete.request.get('status', 'wagons'))
          requests.push($$autocomplete.request.get('state', 'wagons'))
          requests.push($$autocomplete.request.get('client', 'wagons'))
          requests.push($$autocomplete.request.get('elv', 'wagons'))
          requests.push($$autocomplete.request.get('vt', 'wagons'))
          requests.push($$sale.request.getAll())
          requests.push($$autocomplete.request.get('case', 'wagons'))
          requests.push($$autocomplete.request.get('archive', 'wagons'))
          requests.push($$autocomplete.request.get('raadRaat', 'wagons'))

          Promise.all(requests.map(request => request.catch(error => console.log(error))))
            .then((results) => {
              scope.owners = results[0].owners
              scope.types = results[1]
              scope.sets = results[2]
              scope.colors = results[3]
              scope.status = results[4]
              scope.states = results[5]
              scope.clients = results[6]
              scope.elvs = results[7]
              scope.vts = results[8]
              scope.sales = results[9].sales
              scope.cases = results[10]
              scope.archives = results[11]
              scope.raadRaats = results[12]
              scope.salesNames = scope.sales.map(s => s.number)
            })
        } catch (error) {
          toaster.error(error)
        }
      },
    },
  }
}

export default myWagonForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/directives/forms/myWagonForm.js